import React, { useState } from 'react'
import { Row, Col, FormGroup, Label } from "reactstrap"
import { Controller } from 'react-hook-form'
import { User } from 'react-feather'

import StatisticsCard from "@core/components/statistics-card"

const CheckField = (props) => {
  const { formRef, options } = props

  const [listActive, updateListActive] = useState(new Array(options.length || 0).fill(false));

  return (
    <FormGroup className={`${props.hidden && 'hidden'}`}>
      <Label for={props.id} className='form-label'>
        {props.title} <span>{props.required && '*'}</span>
      </Label>
      <Controller
        name={
          props.index !== undefined && props !== null
            ? `${props.name}[${props.index}]`
            : props.name
        }
        rules={{
          required: true,
          minLength: 1,
        }}
        control={formRef.control}
        defaultValue={false}
        render={ctrl => (
          <Row className='pt-1'>
            {
              options.map((option, i) => (
                <Col
                  key={JSON.stringify(option)} xs={12} md={12} lg={6}
                  onClick={() => {
                    const updatedListActive = [...listActive];
                    updatedListActive[i] = !updatedListActive[i];

                    const relevantMembers = [];
                    updatedListActive.forEach((relevant, j) => {
                      if (relevant) relevantMembers.push(options[j])
                    })

                    ctrl.onChange(relevantMembers);
                    updateListActive(updatedListActive);
                  }}
                >
                  <StatisticsCard
                    iconBg="secondary"
                    icon={<User className="info" size={27} />}
                    stat={`${option.name}`}
                    statTitle={option.email}
                    iconRight
                    hideChart
                    colored
                    disabled={!listActive[i] || listActive.length === 0}
                  />
                </Col>
              ))
            }
          </Row>
        )}
      />
    </FormGroup>
  )
}

export default CheckField
